import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Briefcase, MapPin } from "lucide-react";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ChatProvider } from "./context/ChatContext";
import { OndiProvider } from "./context/OndiContext";
import { SOSProvider } from "./context/SOSContext";
import { Header } from "./components/Header";
import { BottomNav } from "./components/BottomNav";
import { NotificationsPrompt } from "./components/NotificationsPrompt";
import { OndiFloater } from "./components/ondi/OndiFloater";
import { SideDrawer } from "./components/navigation/SideDrawer";
import { SOSMasterPanel } from "./components/sos/SOSMasterPanel";
import { ProtectedRoute, GuestOnlyRoute } from "./components/ProtectedRoute";
import AuthPage from "./pages/AuthPage";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import ChatPage from "./pages/ChatPage";
import PulsesPage from "./pages/PulsesPage";
import PlaceholderPage from "./pages/PlaceholderPage";
import MarketPage from "./pages/MarketPage";

function AppShell({ children, hideBottomNav = false }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <div className="App">
      <Header onOpenDrawer={() => setDrawerOpen(true)} />
      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <NotificationsPrompt />
      {children}
      {!hideBottomNav && <BottomNav />}
      <OndiFloater />
      <SOSMasterPanel />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <ChatProvider>
            <OndiProvider>
              <SOSProvider>
              <Toaster
                theme="dark"
                position="top-center"
                richColors
                toastOptions={{
                  style: {
                    background: "rgba(15,23,42,0.92)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "#F8FAFC",
                    backdropFilter: "blur(16px)",
                  },
                }}
              />
            <Routes>
              <Route
                path="/auth"
                element={
                  <GuestOnlyRoute>
                    <AuthPage />
                  </GuestOnlyRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <HomePage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pulsos"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <PulsesPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/perfil"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <ProfilePage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chat/:conversationId"
                element={
                  <ProtectedRoute>
                    <AppShell hideBottomNav>
                      <ChatPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/negocios"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <PlaceholderPage
                        title="Negocios"
                        description="Panel B2B para dueños de negocio: gestiona tu cuenta verificada, tus ofertas activas y tus canales de atención al cliente. En construcción."
                        icon={Briefcase}
                        testIdSlug="negocios"
                      />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/market"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <MarketPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/rincon-latino"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <PlaceholderPage
                        title="Rincón Latino"
                        description="Directorio curado de negocios latinos verificados de la red. Explora, guarda favoritos y contacta directamente por chat. En construcción."
                        icon={MapPin}
                        testIdSlug="rincon"
                      />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
            </Routes>
            </SOSProvider>
            </OndiProvider>
          </ChatProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
